const SvgBreakStatus = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="14" height="14" rx="7" fill="#D0AF36" />
    <path
      d="M5.2 11V7.34C4.86 7.24667 4.575 7.06 4.345 6.78C4.115 6.5 4 6.17333 4 5.8V3H4.8V5.8H5.2V3H6V5.8H6.4V3H7.2V5.8C7.2 6.17333 7.085 6.5 6.855 6.78C6.625 7.06 6.34 7.24667 6 7.34V11H5.2ZM9.2 11V7.8H8V5C8 4.44667 8.195 3.975 8.585 3.585C8.975 3.195 9.44667 3 10 3V11H9.2Z"
      fill="white"
    />
  </svg>
)

export default SvgBreakStatus
